// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"e5271c3c","614":"9d11dd05","680":"d27c4574","766":"db4a68df","975":"155d2a2d"}[chunkId] + ".chunk.js";
};